const brandingName = "Bullhorn Analytics";
const emailSupport = "support-analytics@bullhorn.com";
const bullhornSupportTicketDocsUrl = "https://kb.bullhorn.com/ats/Content/BHATS/Topics/submittingTicketToBullhornSupport.htm";
const submitTicketString = `If you need help please submit a ticket, ${bullhornSupportTicketDocsUrl}`;
const aiAssistantName = "Amplify";

const linkStyle = {
  color: "inherit",
  textDecoration: "underline",

  ":hover": {
    textDecoration: "none"
  }
};

const submitTicketInstructions = <span>
  If you need help please <a style={linkStyle} target="_blank" rel="noreferrer" href={bullhornSupportTicketDocsUrl}>submit a ticket</a>
</span>;

export {
  aiAssistantName,
  brandingName,
  emailSupport,
  bullhornSupportTicketDocsUrl,
  submitTicketString,
  submitTicketInstructions
};